import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=b566ff2c&scoped=true"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"
import style0 from "./CookieNotice.vue?vue&type=style&index=0&id=b566ff2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b566ff2c",
  null
  
)

export default component.exports